import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import api from "../api";
import SegmentCard from "../components/SegmentCard";

export default function SegmentsPage() {
  const [segments, setSegments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [plan, setPlan] = useState("freemium");

  useEffect(() => {
    api
      .get("/api/segments")
      .then((data) => setSegments(Array.isArray(data) ? data : data.segments || []))
      .catch(() => {})
      .finally(() => setLoading(false));
    api
      .get("/api/auth/me")
      .then((u) => setPlan((u.plan || "freemium").toLowerCase()))
      .catch(() => {});
  }, []);

  const handleUpdate = (updated) => {
    setSegments((prev) =>
      prev.map((s) => (s.id === updated.id ? updated : s))
    );
  };

  const handleDelete = (id) => {
    setSegments((prev) => prev.filter((s) => s.id !== id));
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-display font-bold text-ink tracking-tight">Segments</h1>
          <p className="text-sm text-mute mt-1">
            Gérez vos audiences cibles et les instructions IA
          </p>
        </div>
        <Link to="/segments/new" className="btn-primary flex items-center gap-2">
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
          </svg>
          Nouveau segment
        </Link>
      </div>

      {plan !== "premium" && (
        <div className="rounded-xl border border-line bg-paper px-4 py-3 text-sm text-ink/70">
          Freemium : tous les 3 jours, l’envoi auto et la recherche auto sont
          désactivés et LinkedIn est déconnecté.{" "}
          <Link to="/pricing" className="text-rouge underline underline-offset-2">
            Passer Premium
          </Link>{" "}
          pour un fonctionnement continu.
        </div>
      )}

      {loading ? (
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
          {[1, 2].map((i) => (
            <div key={i} className="card p-6 animate-pulse">
              <div className="h-5 bg-ink/5 rounded w-1/3 mb-3" />
              <div className="h-4 bg-ink/5 rounded w-2/3 mb-4" />
              <div className="h-20 bg-ink/3 rounded mb-4" />
              <div className="flex gap-2">
                <div className="h-9 bg-ink/5 rounded-full w-32" />
                <div className="h-9 bg-ink/5 rounded-full w-20" />
              </div>
            </div>
          ))}
        </div>
      ) : segments.length === 0 ? (
        <div className="card p-12 text-center">
          <svg
            className="w-16 h-16 text-ink/10 mx-auto mb-4"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
              d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
            />
          </svg>
          <h3 className="text-lg font-display font-semibold text-ink mb-2 tracking-tight">
            Aucun segment
          </h3>
          <p className="text-sm text-mute mb-6 max-w-md mx-auto">
            Les segments définissent vos audiences cibles. L'IA utilisera
            vos instructions pour envoyer des messages personnalisés
            automatiquement.
          </p>
          <Link to="/segments/new" className="btn-primary inline-flex items-center gap-2">
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
            </svg>
            Créer mon premier segment
          </Link>
        </div>
      ) : (
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
          {segments.map((segment) => (
            <SegmentCard
              key={segment.id}
              segment={segment}
              onUpdate={handleUpdate}
              onDelete={handleDelete}
            />
          ))}
        </div>
      )}
    </div>
  );
}
